import triggerEvent from 'lib/utils/trigger_event';

$(document).on('click', '.js-collage-more', (e) => {
  e.preventDefault();

  const el = e.currentTarget.closest('.collage').querySelector('.js-img-gallery');

  triggerEvent(el, 'click');
});
